// @ts-check

/**
 * Makes a whole section act as a link: clicking any non-interactive area of an
 * element with [data-clickable-section] follows the first link found inside it.
 * Clicks on real interactive elements (links, buttons, inputs) keep their
 * native behavior.
 */

const INTERACTIVE_SELECTOR = 'a, button, input, select, textarea, [role="button"]';

document.addEventListener('click', (event) => {
  if (window.Shopify?.designMode) return;

  const target = event.target;
  if (!(target instanceof Element)) return;

  const section = target.closest('[data-clickable-section]');
  if (!section || target.closest(INTERACTIVE_SELECTOR)) return;

  const link = section.querySelector('a[href]');
  if (!(link instanceof HTMLAnchorElement)) return;

  link.dispatchEvent(
    new MouseEvent('click', {
      ctrlKey: event.ctrlKey,
      metaKey: event.metaKey,
      shiftKey: event.shiftKey,
    })
  );
});
